<!-- TODO: Add user specific settings for choice of language and date format. -->

<!-- Global Web App Configuration Settings -->
<div class="container">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'labels.inputs.Main Configuration' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="layout-column">
        <mat-form-field>
          <mat-label>{{ 'labels.inputs.Default Language' | translate }}</mat-label>
          <mat-select [formControl]="language" [compareWith]="compareOptions">
            @for (language of languages; track language) {
              <mat-option [value]="language">
                {{ language.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'labels.inputs.Default Date Format' | translate }}</mat-label>
          <mat-select [formControl]="dateFormat">
            @for (dateFormat of dateFormats; track dateFormat) {
              <mat-option [value]="dateFormat">
                {{ dateFormat }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'labels.inputs.Decimals to Display' | translate }}</mat-label>
          <mat-select [formControl]="decimalsToDisplay">
            @for (decimalOpt of decimals; track decimalOpt) {
              <mat-option [value]="decimalOpt">
                {{ decimalOpt }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'labels.inputs.Images' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="layout-column">
        <span class="header">{{ 'labels.inputs.Favicon' | translate }}</span>
        <LOSx-file-upload></LOSx-file-upload>

        <span class="header">{{ 'labels.inputs.Cover Image' | translate }}</span>
        <LOSx-file-upload></LOSx-file-upload>

        <span class="header">{{ 'labels.inputs.Logo' | translate }}</span>
        <LOSx-file-upload></LOSx-file-upload>

        <span class="header">{{ 'labels.inputs.Logo with Organization Name' | translate }}</span>
        <LOSx-file-upload></LOSx-file-upload>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'labels.inputs.Theme and Font' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="layout-column">
        <span class="header">{{ 'labels.inputs.Theme' | translate }}</span>
        <LOSx-theme-picker></LOSx-theme-picker>

        <mat-form-field>
          <mat-label>{{ 'labels.inputs.Default Font' | translate }}</mat-label>
          <mat-select>
            @for (font of fonts; track font) {
              <mat-option [value]="font">
                {{ font }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'labels.inputs.Contact Information' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="layout-column">
        <mat-form-field>
          <mat-label>{{ 'labels.inputs.Website' | translate }}</mat-label>
          <input type="url" matInput />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'labels.inputs.Email' | translate }}</mat-label>
          <input type="email" matInput />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'labels.inputs.Contact No' | translate }}</mat-label>
          <input type="tel" matInput />
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
